module.exports = __webpack_public_path__ + "img/authourization.7333d823.svg";